import React, { memo, useEffect, useRef, useState } from 'react';
import { toast } from 'react-toastify';

import { Button, Modal, Switch, Typography } from 'antd';

import axios from 'axios';

type HighTicketTermProps = {
  open: boolean;
  onClose: () => void;
  onSubmit: () => void;
};

const TERMS_PDF_URL = 'https://cdn.eduzzcdn.com/myeduzz/termo-de-adesao-de-cashback-ht.pdf';

async function fetchPdfObjectUrl(): Promise<string> {
  const response = await axios.get(TERMS_PDF_URL, { responseType: 'blob' });
  const blob = response.data as Blob;
  return URL.createObjectURL(blob);
}

function HighTicketTermComponent({ open, onClose, onSubmit }: HighTicketTermProps) {
  const [hasAcceptedTerms, setHasAcceptedTerms] = useState(false);
  const objectUrlRef = useRef<string | null>(null);
  const [pdfSrc, setPdfSrc] = useState<string>('');

  useEffect(
    function setupPdfSource() {
      let cancelled = false;

      const cleanup = () => {
        cancelled = true;
      };

      if (!open) {
        return cleanup;
      }

      setHasAcceptedTerms(false);

      if (objectUrlRef.current) {
        setPdfSrc(objectUrlRef.current);
        return cleanup;
      }

      fetchPdfObjectUrl()
        .then(objUrl => {
          if (cancelled) {
            URL.revokeObjectURL(objUrl);
            return;
          }

          objectUrlRef.current = objUrl;
          setPdfSrc(objUrl);
        })
        .catch(() => {
          setPdfSrc(TERMS_PDF_URL);
          toast.error(
            'Erro ao carregar o termo de responsabilidade. Realizando o download do termo de responsabilidade.'
          );
        });

      return cleanup;
    },
    [open]
  );

  useEffect(function cleanupPdfObjectUrl() {
    return () => {
      if (objectUrlRef.current) {
        URL.revokeObjectURL(objectUrlRef.current);
        objectUrlRef.current = null;
      }
    };
  }, []);

  return (
    <Modal
      open={open}
      onCancel={onClose}
      width={900}
      centered
      title='TERMO DE RESPONSABILIDADE — CONDIÇÃO COMERCIAL HIGH TICKET'
      footer={
        <div className='flex flex-wrap items-center justify-end gap-2'>
          <Button type='text' onClick={onClose}>
            Cancelar
          </Button>
          <Button type='primary' onClick={onSubmit} disabled={!hasAcceptedTerms}>
            Confirmar e salvar
          </Button>
        </div>
      }
    >
      <Typography.Text className='mb-3 block'>
        Ao criar ou editar um produto que se enquadre na condição comercial promocional High Ticket, o PRODUTOR declara
        estar ciente de que:
      </Typography.Text>

      <div className='h-112.5 w-full border-0'>
        <iframe src={`${pdfSrc}#toolbar=1`} title='termo-de-responsabilidade' className='size-full border-0' />
      </div>

      <div className='mt-4 flex items-center gap-2'>
        <Switch checked={hasAcceptedTerms} onChange={setHasAcceptedTerms} />
        <Typography.Text>Li e aceito o termo de responsabilidade</Typography.Text>
      </div>
    </Modal>
  );
}

export const HighTicketTerm = memo(HighTicketTermComponent);
